import React from "react";
import { Form, useDataProvider, useNotify, useRefresh } from "react-admin";
import { Grid } from "@mui/material";
import SaveForm from "../../../SickLeaves/SaveForm"
import { employeeRequests } from "api/employeeApi";
import { SICK_LEAVE_DOCUMENT_TYPE } from "utils/constants";
import { useNotifyError } from "utils/useNotifyError";

const SickLeaveRequest = ({ onSuccess, setLeaveId }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const notifyError = useNotifyError();

  const handleSuccessResponse = () => {
    notify("Заявката беше регистрирана! Ще получите имейл нотификация при одобрението ѝ.", { type: "success" });
    onSuccess();
    refresh();
  }

  const handleSubmit = async (values) => {
    try {
      await dataProvider.customRequest(
        employeeRequests.createSickLeave(),
        values,
        "POST",
        null,
        true
      );
      handleSuccessResponse();
    } catch (e) {
      notifyError(e);
    }
  }
  return (
    <Grid container spacing={0}>
      <Grid item xs={12} md={8} lg={4} p={0.5}>
        <Form
          onSubmit={handleSubmit}
          defaultValues={{ documentNumber: SICK_LEAVE_DOCUMENT_TYPE }}
        >
          <SaveForm 
            isCreate={true}
            setLeaveId={setLeaveId}
          />
        </Form>
      </Grid>
    </Grid>
  )
}

export default SickLeaveRequest;